/** Parent-domain cookie so cms and funnel share one install-bar decision per browser. */
export const APP_INSTALL_BAR_COOKIE = "app_install_bar";
export const APP_INSTALL_PROMPT_READY_EVENT = "app-install-prompt-ready";

export type AppInstallBarDecision = "accepted" | "dismissed";

/** Chrome's cap (Chrome 104+); anything longer is cut to this anyway. */
const MAX_AGE_IN_SECONDS = 400 * 24 * 60 * 60;

/** Last two labels, like the Kameleoon cookie; wrong for .co.uk but this feature is DE only. */
export const getAppInstallBarCookieDomain = (hostname: string): string | null => {
  const host = hostname.replace(/\.$/, "");
  if (host === "localhost" || /^[\d.]+$/.test(host) || host.includes(":")) return null;
  const labels = host.split(".");
  return labels.length < 2 ? null : labels.slice(-2).join(".");
};

export const hasAppInstallBarDecision = (): boolean => {
  try {
    return new RegExp(`(^|;\\s*)${APP_INSTALL_BAR_COOKIE}=`).test(document.cookie);
  } catch {
    return false;
  }
};

export const saveAppInstallBarDecision = (value: AppInstallBarDecision): void => {
  try {
    const domain = getAppInstallBarCookieDomain(window.location.hostname);
    document.cookie =
      `${APP_INSTALL_BAR_COOKIE}=${value}; Max-Age=${MAX_AGE_IN_SECONDS}; Path=/; SameSite=Lax` +
      (domain ? `; Domain=.${domain}` : "") +
      (window.location.protocol === "https:" ? "; Secure" : "");
  } catch {
    // Cookies blocked: the bar can come back on the next load, nothing breaks.
  }
};
